<template>
    <div>
        <div class="dialog-content-container">
            <p>Are you sure to save</p>
        </div>
        <div class="dialog-action-container">
            <v-btn color="agrinome_primary" dark @click="confirmSave()">Yes</v-btn>
        </div>
    </div>
</template>

<script>
export default {
    props: ["props", "successFn"],
    methods: {
        confirmSave() {
            this.successFn();
            this.$emit("onClose");
        }   
    }
};
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/smallComponents/Dialog/DialogContent/SaveConfirmation.vue